import axios from 'axios'
import _ from 'lodash'
import server from '.'
import { message as Message } from 'ant-design-vue'

function HTTP(baseurl, timeout) {
  return axios.create({
    baseURL: baseurl,
    timeout: timeout
  })
}
// 检查状态
export function checkState(data) {
  if (data.hasOwnProperty('state') && data['state'] > 4000 && data['state'] < 5000) {
    window.location.href = '/login'
  }
}

export function HTTPWithInterceptors(baseurl, timeout) {
  let http = axios.create({
    baseURL: baseurl,
    timeout: timeout * 1000
  })
  http.interceptors.request.use(function(config) {
    // 在发送请求之前做些什么
    return config
  }, function(error) {
    // 对请求错误做些什么
    Message.error('前端出错: ' + error.message)
    return Promise.reject(error)
    // return Promise.resolve(error)
  })

  http.interceptors.response.use(function(response) {
    // 2xx范围内的状态码都会触发该函数
    server.logger.debug(response) // 打印日志
    checkState(response.data)
    return response
  }, function(error) {
    // 超出2xx范围的状态码都会触发该函数
    if (error.response && error.response.data && error.response.data.message) {
      var jsonObj = JSON.parse(error.response.data.message)
      Message.error(jsonObj)
    } else {
      Message.error(error.message)
    }
    return Promise.reject(error)
  })
  return http
}

// loading对象
let loading
// 当前正在请求的数量
let needLoadingRequestCount = 0
// 显示loading
function showLoading(target) {
  // 后面这个判断很重要，因为关闭时加了抖动，此时loading对象可能还存在，
  // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
  if (needLoadingRequestCount === 0 && !loading) {
    // loading = Loading.service({
    //   lock: true,
    //   text: 'Loading...',
    //   background: 'rgba(255, 255, 255, 0.5)',
    //   target: target || 'body'
    // })
    // loading = Loading.service({
    //   target: '.app-main',
    //   text: '加载中...',
    //   spinner: 'el-icon-loading',
    //   background: 'rgba(0, 0, 0, 0.7)'
    // })
    // console.log('显示loading...')
    // Spin.setDefaultIndicator({
    //   spinning: true
    // })
  }
  needLoadingRequestCount++
}

// 隐藏loading
function hideLoading() {
  needLoadingRequestCount--
  needLoadingRequestCount = Math.max(needLoadingRequestCount, 0) // 做个保护
  if (needLoadingRequestCount === 0) {
    toHideLoading() // 关闭loading
  }
}

// 防抖：将 300ms 间隔内的关闭 loading 便合并为一次。防止连续请求时， loading闪烁的问题。
var toHideLoading = _.debounce(() => {
  // loading.close()
  // Spin.setDefaultIndicator({
  //   spinning: false
  // })
  loading = null
}, 300)

export default HTTP
export { hideLoading, showLoading }



// WEBPACK FOOTER //
// ./src/server/http.js